import {
    FETCH_USER_PROPERTIES_CONTENT,
    FETCH_USER_PROPERTIES_CONTENT_SUCCESS,
    FETCH_USER_PROPERTIES_CONTENT_FAILED,
    USER_PROPERTIES_DELETE__MESSAGE,
    USER_PROPERTIES_DELETE_MESSAGE_SUCCESS,
    USER_PROPERTIES_DELETE__MESSAGE_FAILED,
    USER_PROPERTIES_CANCEL__MESSAGE,
    USER_PROPERTIES_CANCEL__MESSAGE_FAILED,
    USER_PROPERTIES_CANCEL_MESSAGE_SUCCESS
} from "../actions/actionTypes";

const initialState = {
    isLoading: true,
    content: {},
    error: false,
    isFormProcessing: false,
    emptyFormData: false,
    isPropertyCancelProcessing: false
};

export default function (state = initialState, { type, payload }) {

    switch (type) {
        case FETCH_USER_PROPERTIES_CONTENT:
            return {
                ...state,
                isLoading: true,
                content: {},
            };
        case FETCH_USER_PROPERTIES_CONTENT_SUCCESS:
            return {
                ...state,
                isLoading: false,
                content: payload,
            };
        case FETCH_USER_PROPERTIES_CONTENT_FAILED:
            return {
                ...state,
                isLoading: false,
                error: payload,
            };
        case USER_PROPERTIES_DELETE__MESSAGE:
            return {
                ...state,
                isFormProcessing: true,
            };
        case USER_PROPERTIES_DELETE_MESSAGE_SUCCESS:
            return {
                ...state,
                isFormProcessing: false,
                emptyFormData: true
            };
        case USER_PROPERTIES_DELETE__MESSAGE_FAILED:
            return {
                ...state,
                isFormProcessing: false,
                error: payload
            };
        case USER_PROPERTIES_CANCEL__MESSAGE:
            return {
                ...state,
                isPropertyCancelProcessing: true,
            };
        case USER_PROPERTIES_CANCEL_MESSAGE_SUCCESS:
            return {
                ...state,
                isPropertyCancelProcessing: false,
                emptyFormData: true
            };
        case USER_PROPERTIES_CANCEL__MESSAGE_FAILED:
            return {
                ...state,
                isPropertyCancelProcessing: false,
                error: payload
            };
        default:
            return state;
    }
}
